<div class="loading-overlay" *ngIf="loaderBool === 'true'">
    <div class="overiner text-right">
      <div class="overiner-sub">
        <div class="loader"></div>
      </div>
    </div>
  </div>
  